export default __webpack_public_path__ + "static/media/property_902.8b545b4f.png";